import Vue from 'vue'
import Vuex from 'vuex'
import AvatarVoiceFIcon from '../../assets/avatarVoiceF.png'
import AvatarVoiceMIcon from '../../assets/avatarVoiceM.png'

Vue.use(Vuex)


export const store = new Vuex.Store({
	state: {
		countries: [
			"Afghanistan",
			"Åland Islands",
			"Albania",
			"Algeria",
			"American Samoa",
			"Andorra",
			"Angola",
			"Anguilla",
			"Antarctica",
			"Antigua and Barbuda",
			"Argentina",
			"Armenia",
			"Aruba",
			"Australia",
			"Austria",
			"Azerbaijan",
			"Bahamas",
			"Bahrain",
			"Bangladesh",
			"Barbados",
			"Belarus",
			"Belgium",
			"Belize",
			"Benin",
			"Bermuda",
			"Bhutan",
			"Bolivia (Plurinational State of)",
			"Bonaire",
			" Sint Eustatius and Saba",
			"Bosnia and Herzegovina",
			"Botswana",
			"Bouvet Island",
			"Brazil",
			"British Indian Ocean Territory",
			"United States Minor Outlying Islands",
			"Virgin Islands (British)",
			"Virgin Islands (U.S.)",
			"Brunei Darussalam",
			"Bulgaria",
			"Burkina Faso",
			"Burundi",
			"Cambodia",
			"Cameroon",
			"Canada",
			"Cabo Verde",
			"Cayman Islands",
			"Central African Republic",
			"Chad",
			"Chile",
			"China",
			"Christmas Island",
			"Cocos (Keeling) Islands",
			"Colombia",
			"Comoros",
			"Congo",
			"Congo",
			"Costa Rica",
			"Croatia",
			"Cuba",
			"Curaçao",
			"Cyprus",
			"Czech Republic",
			"Denmark",
			"Djibouti",
			"Dominica",
			"Dominican Republic",
			"Ecuador",
			"Egypt",
			"El Salvador",
			"Equatorial Guinea",
			"Eritrea",
			"Estonia",
			"Ethiopia",
			"Falkland Islands (Malvinas)",
			"Faroe Islands",
			"Fiji",
			"Finland",
			"France",
			"French Guiana",
			"French Polynesia",
			"French Southern Territories",
			"Gabon",
			"Gambia",
			"Georgia",
			"Germany",
			"Ghana",
			"Gibraltar",
			"Greece",
			"Greenland",
			"Grenada",
			"Guadeloupe",
			"Guam",
			"Guatemala",
			"Guernsey",
			"Guinea",
			"Guinea-Bissau",
			"Guyana",
			"Haiti",
			"Heard Island and McDonald Islands",
			"Holy See",
			"Honduras",
			"Hong Kong",
			"Hungary",
			"Iceland",
			"India",
			"Indonesia",
			"Côte d'Ivoire",
			"Iran (Islamic Republic of)",
			"Iraq",
			"Ireland",
			"Isle of Man",
			"Israel",
			"Italy",
			"Jamaica",
			"Japan",
			"Jersey",
			"Jordan",
			"Kazakhstan",
			"Kenya",
			"Kiribati",
			"Kuwait",
			"Kyrgyzstan",
			"Lao People's Democratic Republic",
			"Latvia",
			"Lebanon",
			"Lesotho",
			"Liberia",
			"Libya",
			"Liechtenstein",
			"Lithuania",
			"Luxembourg",
			"Macao",
			"Macedonia",
			"Madagascar",
			"Malawi",
			"Malaysia",
			"Maldives",
			"Mali",
			"Malta",
			"Marshall Islands",
			"Martinique",
			"Mauritania",
			"Mauritius",
			"Mayotte",
			"Mexico",
			"Micronesia (Federated States of)",
			"Moldova (Republic of)",
			"Monaco",
			"Mongolia",
			"Montenegro",
			"Montserrat",
			"Morocco",
			"Mozambique",
			"Myanmar",
			"Namibia",
			"Nauru",
			"Nepal",
			"Netherlands",
			"New Caledonia",
			"New Zealand",
			"Nicaragua",
			"Niger",
			"Nigeria",
			"Niue",
			"Norfolk Island",
			"Korea (Democratic People's Republic of)",
			"Northern Mariana Islands",
			"Norway",
			"Oman",
			"Pakistan",
			"Palau",
			"Palestine",
			"Panama",
			"Papua New Guinea",
			"Paraguay",
			"Peru",
			"Philippines",
			"Pitcairn",
			"Poland",
			"Portugal",
			"Puerto Rico",
			"Qatar",
			"Republic of Kosovo",
			"Réunion",
			"Romania",
			"Russian Federation",
			"Rwanda",
			"Saint Barthélemy",
			"Saint Helena",
			"Ascension and Tristan da Cunha",
			"Saint Kitts and Nevis",
			"Saint Lucia",
			"Saint Martin (French part)",
			"Saint Pierre and Miquelon",
			"Saint Vincent and the Grenadines",
			"Samoa",
			"San Marino",
			"Sao Tome and Principe",
			"Saudi Arabia",
			"Senegal",
			"Serbia",
			"Seychelles",
			"Sierra Leone",
			"Singapore",
			"Sint Maarten (Dutch part)",
			"Slovakia",
			"Slovenia",
			"Solomon Islands",
			"Somalia",
			"South Africa",
			"South Georgia and the South Sandwich Islands",
			"Korea (Republic of)",
			"South Sudan",
			"Spain",
			"Sri Lanka",
			"Sudan",
			"Suriname",
			"Svalbard and Jan Mayen",
			"Swaziland",
			"Sweden",
			"Switzerland",
			"Syrian Arab Republic",
			"Taiwan",
			"Tajikistan",
			"Tanzania",
			" United Republic of",
			"Thailand",
			"Timor-Leste",
			"Togo",
			"Tokelau",
			"Tonga",
			"Trinidad and Tobago",
			"Tunisia",
			"Turkey",
			"Turkmenistan",
			"Turks and Caicos Islands",
			"Tuvalu",
			"Uganda",
			"Ukraine",
			"United Arab Emirates",
			"United Kingdom",
			"United States of America",
			"Uruguay",
			"Uzbekistan",
			"Vanuatu",
			"Venezuela (Bolivarian Republic of)",
			"Viet Nam",
			"Wallis and Futuna",
			"Western Sahara",
			"Yemen",
			"Zambia",
			"Zimbabwe"
		],
		samples: [
			{
				avatar: AvatarVoiceFIcon,
				title: 'Celesta',
				person: 'Celesta',
				gender: 'female',
				languageName: 'Spanish',
				languageCode: "es-ES",
				languageCodeFull: "es-ES-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/es_es_s1_Celesta.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/es_es_s1_Celesta.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Grete',
				person: 'Grete',
				gender: 'female',
				languageName: 'Danish',
				languageCode: "da-DK",
				languageCodeFull: "da-DK-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/da_dk_s1_Grete.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/da_dk_s2_Grete.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ingrid',
				person: 'Ingrid',
				gender: 'female',
				languageName: 'Danish',
				languageCode: "da-DK",
				languageCodeFull: "da-DK-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/da_dk_s3_Ingrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/da_dk_s4_Ingrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Adelie',
				person: 'Adelie',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s1_Adelie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s1_Adelie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Hannah',
				person: 'Hannah',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s2_Hannah.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s2_Hannah.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Liezel',
				person: 'Liezel',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s3_Liezel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s3_Liezel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Dietmar',
				person: 'Dietmar',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s1_Dietmar.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s1_Dietmar.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Knut',
				person: 'Knut',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s2_Knut.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s2_Knut.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Siegfrid',
				person: 'Siegfrid',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s3_Siegfrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s3_Siegfrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Allese',
				person: 'Allese',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s1_Allese.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s1_Allese.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Chloe',
				person: 'Chloe',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s2_Chloe.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s2_Chloe.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Louise',
				person: 'Louise',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s3_Louise.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s3_Louise.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Symone',
				person: 'Symone',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s4_Symone.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s4_Symone.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Emanuel',
				person: 'Emanuel',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Fabien',
				person: 'Fabien',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s2_Fabien.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s2_Fabien.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Raphael',
				person: 'Raphael',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s3_Raphael.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s3_Raphael.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Thierry',
				person: 'Thierry',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s4_Thierry.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s4_Thierry.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Jerome',
				person: 'Jerome',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s1_Jerome.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s1_Jerome.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Maurice',
				person: 'Maurice',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s2_Maurice.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s2_Maurice.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Sinclaire',
				person: 'Sinclaire',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Travis',
				person: 'Travis',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s4_Travis.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s4_Travis.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Amelie',
				person: 'Amelie',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s1_Amelie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s1_Amelie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Dennise',
				person: 'Dennise',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s2_Dennise.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s2_Dennise.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lisette',
				person: 'Lisette',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s3_Lisette.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s3_Lisette.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Sophie',
				person: 'Sophie',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s4_Sophie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s4_Sophie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Giulia',
				person: 'Giulia',
				gender: 'female',
				languageName: 'Italian',
				languageCode: "it-IT",
				languageCodeFull: "it-IT-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/it_it_s1_Giulia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/it_it_s2_Giulia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Francesca',
				person: 'Francesca',
				gender: 'female',
				languageName: 'Italian',
				languageCode: "it-IT",
				languageCodeFull: "it-IT-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/it_it_s3_Francesca.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/it_it_s4_Francesca.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'ChinSun',
				person: 'ChinSun',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'HaJoon',
				person: 'HaJoon',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'KyungMi',
				person: 'KyungMi',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'MinJung',
				person: 'MinJung',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s4_MinJung.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s4_MinJung.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'DongMin',
				person: 'DongMin',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s1_DongMin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s1_DongMin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'HoSook',
				person: 'HoSook',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s2_HoSook.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s2_HoSook.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'SangOok',
				person: 'SangOok',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s3_SangOok.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s3_SangOok.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'YooJoon',
				person: 'YooJoon',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Annemari',
				person: 'Annemari',
				gender: 'female',
				languageName: 'Norwegian',
				languageCode: "nb-NO",
				languageCodeFull: "nb-NO-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nb_no_s1_Annemari.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nb_no_s2_Annemari.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Kaari',
				person: 'Kaari',
				gender: 'female',
				languageName: 'Norwegian',
				languageCode: "nb-NO",
				languageCodeFull: "nb-NO-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nb_no_s3_Kaari.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nb_no_s4_Kaari.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Jasmijn',
				person: 'Jasmijn',
				gender: 'female',
				languageName: 'Dutch, Netherlands',
				languageCode: "nl-NL",
				languageCodeFull: "nl-NL-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nl_nl_s1_Jasmijn.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nl_nl_s2_Jasmijn.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lotte',
				person: 'Lotte',
				gender: 'female',
				languageName: 'Dutch, Netherlands',
				languageCode: "nl-NL",
				languageCodeFull: "nl-NL-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nl_nl_s3_Lotte.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nl_nl_s4_Lotte.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Bozena',
				person: 'Bozena',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s1_Bozena.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s1_Bozena.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Elzbieta',
				person: 'Elzbieta',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Halinka',
				person: 'Halinka',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s3_Halinka.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s3_Halinka.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lidia',
				person: 'Lidia',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s4_Lidia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s4_Lidia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Natasza',
				person: 'Natasza',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s5_Natasza.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s5_Natasza.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Zuzanna',
				person: 'Zuzanna',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Antek',
				person: 'Antek',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s1_Antek.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s1_Antek.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Bolek',
				person: 'Bolek',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s2_Bolek.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s2_Bolek.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Szymon',
				person: 'Szymon',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s3_Szymon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s3_Szymon.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Wojciech',
				person: 'Wojciech',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Francisca',
				person: 'Francisca',
				gender: 'female',
				languageName: 'Portuguese, Brazil',
				languageCode: "pt-BR",
				languageCodeFull: "pt-BR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_br_s1_Francisca.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_br_s1_Francisca.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Marcia',
				person: 'Marcia',
				gender: 'female',
				languageName: 'Portuguese, Brazil',
				languageCode: "pt-BR",
				languageCodeFull: "pt-BR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_br_s2_Marcia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_br_s2_Marcia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Beatriz',
				person: 'Beatriz',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Cesaria',
				person: 'Cesaria',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Leonor',
				person: 'Leonor',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s3_Leonor.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s3_Leonor.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Miciela',
				person: 'Miciela',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s4_Miciela.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s4_Miciela.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Alfonso',
				person: 'Alfonso',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Filipe',
				person: 'Filipe',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s2_Filipe.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s2_Filipe.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Miguel',
				person: 'Miguel',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s3_Miguel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s3_Miguel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Rodrigo',
				person: 'Rodrigo',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Artem',
				person: 'Artem',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s1_Artem.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s1_Artem.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Igor',
				person: 'Igor',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s2_Igor.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s2_Igor.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Sergey',
				person: 'Sergey',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s3_Sergey.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s3_Sergey.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Vova',
				person: 'Vova',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s4_Vova.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s4_Vova.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Anya',
				person: 'Anya',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s1_Anya.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s1_Anya.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Katja',
				person: 'Katja',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s2_Katja.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s2_Katja.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Nastya',
				person: 'Nastya',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s3_Nastya.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s3_Nastya.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Olga',
				person: 'Olga',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s4_Olga.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s4_Olga.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Dalenka',
				person: 'Dalenka',
				gender: 'female',
				languageName: 'Slovak',
				languageCode: "sk-SK",
				languageCodeFull: "sk-SK-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ladislava',
				person: 'Ladislava',
				gender: 'female',
				languageName: 'Slovak',
				languageCode: "sk-SK",
				languageCodeFull: "sk-SK-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Astrid',
				person: 'Astrid',
				gender: 'female',
				languageName: 'Swedish',
				languageCode: "sv-SE",
				languageCodeFull: "sv-SE-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sv_se_s1_Astrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sv_se_s1_Astrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Caren',
				person: 'Caren',
				gender: 'female',
				languageName: 'Swedish',
				languageCode: "sv-SE",
				languageCodeFull: "sv-SE-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sv_se_s2_Caren.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sv_se_s2_Caren.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Aylin',
				person: 'Aylin',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s1_Aylin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s1_Aylin.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Emel',
				person: 'Emel',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s2_Emel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s2_Emel.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Filiz',
				person: 'Filiz',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s3_Filiz.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s3_Filiz.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Nehir',
				person: 'Nehir',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s4_Nehir.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s4_Nehir.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Reyhan',
				person: 'Reyhan',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Zeynep',
				person: 'Zeynep',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ahmet',
				person: 'Ahmet',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ergin',
				person: 'Ergin',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s2_Ergin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s2_Ergin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Muhammed',
				person: 'Muhammed',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Yusuf',
				person: 'Yusuf',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Maryska',
				person: 'Maryska',
				gender: 'female',
				languageName: 'Ukrainian',
				languageCode: "uk-UA",
				languageCodeFull: "uk-UA-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/uk_ua_s1_Maryska.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/uk_ua_s1_Maryska.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Veronika',
				person: 'Veronika',
				gender: 'female',
				languageName: 'Ukrainian',
				languageCode: "uk-UA",
				languageCodeFull: "uk-UA-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/uk_ua_s2_Veronika.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/uk_ua_s2_Veronika.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Fumiko',
				person: 'Fumiko',
				gender: 'female',
				languageName: 'Japan',
				languageCode: "ja-JP",
				languageCodeFull: "ja-JP-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Akira',
				person: 'Akira',
				gender: 'female',
				languageName: 'Japan',
				languageCode: "ja-JP",
				languageCodeFull: "ja-JP-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ja_jp_s1_Akira.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ja_jp_s1_Akira.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Susan',
				person: 'Susan',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-F",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s5_Susan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s5_Susan.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Pamela',
				person: 'Pamela',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s4_Pamela.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s4_Pamela.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Karen',
				person: 'Karen',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s3_Karen.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s3_Karen.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Jodie',
				person: 'Jodie',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s2_Jodie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s2_Jodie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Beckie',
				person: 'Beckie',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s1_Beckie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s1_Beckie.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Wesley',
				person: 'Wesley',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s5_Wesley.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s5_Wesley.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Robin',
				person: 'Robin',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s4_Robin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s4_Robin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Jason',
				person: 'Jason',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s3_Jason.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s3_Jason.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Earl',
				person: 'Earl',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s2_Earl.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s2_Earl.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Anthony',
				person: 'Anthony',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s1_Anthony.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s1_Anthony.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Parker',
				person: 'Parker',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s4_Parker.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s4_Parker.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Oliver',
				person: 'Oliver',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s3_Oliver.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s3_Oliver.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Keeton',
				person: 'Keeton',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s2_Keeton.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s2_Keeton.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Alen',
				person: 'Alen',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s1_Alen.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s1_Alen.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Maddy',
				person: 'Maddy',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s4_Maddy.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s4_Maddy.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Hailey',
				person: 'Hailey',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s3_Hailey.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s3_Hailey.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ella',
				person: 'Ella',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s2_Ella.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s2_Ella.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Alice',
				person: 'Alice',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s1_Alice.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s1_Alice.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Mason',
				person: 'Mason',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s4_Mason.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s4_Mason.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Harper',
				person: 'Harper',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s3_Harper.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s3_Harper.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ethan',
				person: 'Ethan',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s2_Ethan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s2_Ethan.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Daymion',
				person: 'Daymion',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s1_Daymion.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s1_Daymion.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Daisy',
				person: 'Daisy',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s1_Daisy.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s1_Daisy.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Fiona',
				person: 'Fiona',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s2_Fiona.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s2_Fiona.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Kiara',
				person: 'Kiara',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s3_Kiara.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s3_Kiara.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Madeline',
				person: 'Madeline',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s4_Madeline.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s4_Madeline.oga')
			}
		],

		languages: [
			{
				language: 'Danish (Denmark)', code: 'da-DK',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Grete",
								code: "da-DK-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/da_dk_s1_Grete.mp3')
							},
							{
								name: "Ingrid",
								code: "da-DK-Wavenet-A",
								vendor: "Google",
								voiceType: "Wavenet",
								voiceSample: require('../../assets/audio/gallery/da_dk_s3_Ingrid.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Dutch (Netherlands)', code: 'nl-NL',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Jasmijn",
								code: "nl-NL-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/nl_nl_s1_Jasmijn.mp3')
							},
							{
								name: "Lotte",
								code: "nl-NL-Wavenet-A",
								vendor: "Google",
								voiceType: "Wavenet",
								voiceSample: require('../../assets/audio/gallery/nl_nl_s3_Lotte.mp3')
							}
						]
					}
				]
			},
			{
				language: 'English (Australia)', code: 'en-AU',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Daisy",
								code: "en-AU-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_au_s1_Daisy.mp3')

							},
							{
								name: "Fiona",
								code: "en-AU-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_au_s2_Fiona.mp3')

							},
							{
								name: "Kiara",
								code: "en-AU-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_au_s3_Kiara.mp3')

							},
							{
								name: "Madeline",
								code: "en-AU-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_au_s4_Madeline.mp3')

							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Daymion",
								code: "en-AU-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_au_s1_Daymion.mp3')

							},
							{
								name: "Ethan",
								code: "en-AU-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_au_s2_Ethan.mp3')

							},
							{
								name: "Harper",
								code: "en-AU-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_au_s3_Harper.mp3')

							},
							{
								name: "Mason",
								code: "en-AU-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_au_s4_Mason.mp3')

							}
						]
					}
				]
			},
			{
				language: 'English (UK)', code: 'en-GB',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Alice",
								code: "en-GB-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_gb_s1_Alice.mp3')

							},
							{
								name: "Ella",
								code: "en-GB-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_gb_s2_Ella.mp3')

							},
							{
								name: "Hailey",
								code: "en-GB-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_gb_s3_Hailey.mp3')

							},
							{
								name: "Maddy",
								code: "en-GB-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_gb_s4_Maddy.mp3')

							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Alen",
								code: "en-GB-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_gb_s1_Alen.mp3')

							},
							{
								name: "Keeton",
								code: "en-GB-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_gb_s2_Keeton.mp3')

							},
							{
								name: "Oliver",
								code: "en-GB-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_gb_s3_Oliver.mp3')

							},
							{
								name: "Parker",
								code: "en-GB-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_gb_s4_Parker.mp3')

							}
						]
					}
				]
			},
			{
				language: 'English (US)', code: 'en-US',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Beckie",
								code: "en-US-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_us_s1_Beckie.mp3')

							},
							{
								name: "Jodie",
								code: "en-US-Standard-E",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_us_s2_Jodie.mp3')

							},
							{
								name: "Karen",
								code: "en-US-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s3_Karen.mp3')

							},
							{
								name: "Pamela",
								code: "en-US-Wavenet-E",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s4_Pamela.mp3')

							},
							{
								name: "Susan",
								code: "en-US-Wavenet-F",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s5_Susan.mp3')

							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Anthony",
								code: "en-US-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_us_s1_Anthony.mp3')

							},
							{
								name: "Earl",
								code: "en-US-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/en_us_s2_Earl.mp3')

							},
							{
								name: "Jason",
								code: "en-US-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s3_Jason.mp3')

							},
							{
								name: "Robin",
								code: "en-US-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s4_Robin.mp3')

							},
							{
								name: "Wesley",
								code: "en-US-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/en_us_s5_Wesley.mp3')
							}
						]
					}
				]
			},
			{
				language: 'French (Canada)', code: 'fr-CA',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Allese",
								code: "fr-CA-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s1_Allese.mp3')
							},
							{
								name: "Chloe",
								code: "fr-CA-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s2_Chloe.mp3')
							},
							{
								name: "Louise",
								code: "fr-CA-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s3_Louise.mp3')
							},
							{
								name: "Symone",
								code: "fr-CA-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s4_Symone.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Emanuel",
								code: "fr-CA-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.mp3')
							},
							{
								name: "Fabien",
								code: "fr-CA-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s2_Fabien.mp3')
							},
							{
								name: "Raphael",
								code: "fr-CA-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s3_Raphael.mp3')
							},
							{
								name: "Thierry",
								code: "fr-CA-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_ca_s4_Thierry.mp3')
							}
						]
					}
				]
			},
			{
				language: 'French (France)', code: 'fr-FR',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Amelie",
								code: "fr-FR-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s1_Amelie.mp3')
							},
							{
								name: "Dennise",
								code: "fr-FR-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s2_Dennise.mp3')
							},
							{
								name: "Lisette",
								code: "fr-FR-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s3_Lisette.mp3')
							},
							{
								name: "Sophie",
								code: "fr-FR-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s4_Sophie.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Jerome",
								code: "fr-FR-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s1_Jerome.mp3')
							},
							{
								name: "Maurice",
								code: "fr-FR-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s2_Maurice.mp3')
							},
							{
								name: "Sinclaire",
								code: "fr-FR-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.mp3')
							},
							{
								name: "Travis",
								code: "fr-FR-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/fr_fr_s4_Travis.mp3')
							}
						]
					}
				]
			},
			{
				language: 'German (Germany)', code: 'de-DE',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Adelie",
								code: "de-DE-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/de_de_s1_Adelie.mp3')
							},
							{
								name: "Hannah",
								code: "de-DE-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/de_de_s2_Hannah.mp3')
							},
							{
								name: "Liezel",
								code: "de-DE-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/de_de_s3_Liezel.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Dietmar",
								code: "de-DE-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/de_de_s1_Dietmar.mp3')

							},
							{
								name: "Knut",
								code: "de-DE-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/de_de_s2_Knut.mp3')
							},
							{
								name: "Siegfrid",
								code: "de-DE-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/de_de_s3_Siegfrid.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Italian (Italy)', code: 'it-IT',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Giulia",
								code: "it-IT-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/it_it_s1_Giulia.mp3')
							},
							{
								name: "Francesca",
								code: "it-IT-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/it_it_s3_Francesca.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Japanese (Japan)', code: 'ja-JP',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Akira",
								code: "ja-JP-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ja_jp_s1_Akira.mp3')

							},
							{
								name: "Fumiko",
								code: "ja-JP-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.mp3')

							}
						]
					}
				]
			},
			{
				language: 'Korean (South Korea)', code: 'ko-KR',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Chin-Sun",
								code: "ko-KR-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.mp3')
							},
							{
								name: "Ho-Sook",
								code: "ko-KR-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s2_HoSook.mp3')
							},
							{
								name: "Kyung Mi",
								code: "ko-KR-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.mp3')
							},
							{
								name: "Min Jung",
								code: "ko-KR-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s4_MinJung.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Dong-Min",
								code: "ko-KR-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s1_DongMin.mp3')

							},
							{
								name: "Ha Joon",
								code: "ko-KR-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.mp3')
							},
							{
								name: "Sang-Ook",
								code: "ko-KR-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s3_SangOok.mp3')
							},
							{
								name: "Yoo Joon",
								code: "ko-KR-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Norwegian (Norway)', code: 'nb-NO',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Annemari",
								code: "nb-NO-Standard-E",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/nb_no_s1_Annemari.mp3')
							},
							{
								name: "Kaari",
								code: "nb-NO-Wavenet-E",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/nb_no_s3_Kaari.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Polish (Poland)', code: 'pl-PL',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Bozena",
								code: "pl-PL-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s1_Bozena.mp3')
							},
							{
								name: "Elzbieta",
								code: "pl-PL-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.mp3')
							},
							{
								name: "Halinka",
								code: "pl-PL-Standard-E",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s3_Halinka.mp3')
							},
							{
								name: "Lidia",
								code: "pl-PL-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s4_Lidia.mp3')
							},
							{
								name: "Natasza",
								code: "pl-PL-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s5_Natasza.mp3')
							},
							{
								name: "Zuzanna",
								code: "pl-PL-Wavenet-E",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Antek",
								code: "pl-PL-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s1_Antek.mp3')
							},
							{
								name: "Bolek",
								code: "pl-PL-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s2_Bolek.mp3')
							},
							{
								name: "Szymon",
								code: "pl-PL-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s3_Szymon.mp3')
							},
							{
								name: "Wojciech",
								code: "pl-PL-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Portuguese (Brazil)', code: 'pt-BR',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Francisca",
								code: "pt-BR-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pt_br_s1_Francisca.mp3')
							},
							{
								name: "Marcia",
								code: "pt-BR-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pt_br_s2_Marcia.mp3')

							}
						]
					}
				]
			},
			{
				language: 'Portuguese (Portugal)', code: 'pt-PT',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Beatriz",
								code: "pt-PT-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.mp3')
							},
							{
								name: "Cesaria",
								code: "pt-PT-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.mp3')
							},
							{
								name: "Leonor",
								code: "pt-PT-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s3_Leonor.mp3')

							},
							{
								name: "Miciela",
								code: "pt-PT-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s4_Miciela.mp3')

							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Alfonso",
								code: "pt-PT-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.mp3')

							},
							{
								name: "Filipe",
								code: "pt-PT-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s2_Filipe.mp3')
							},
							{
								name: "Miguel",
								code: "pt-PT-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s3_Miguel.mp3')
							},
							{
								name: "Rodrigo",
								code: "pt-PT-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Russian (Russia)', code: 'ru-RU',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Anya",
								code: "ru-RU-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s1_Anya.mp3')
							},
							{
								name: "Katja",
								code: "ru-RU-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s2_Katja.mp3')
							},
							{
								name: "Nastya",
								code: "ru-RU-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s3_Nastya.mp3')
							},
							{
								name: "Olga",
								code: "ru-RU-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s4_Olga.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Artem",
								code: "ru-RU-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s1_Artem.mp3')
							},
							{
								name: "Igor",
								code: "ru-RU-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s2_Igor.mp3')
							},
							{
								name: "Sergey",
								code: "ru-RU-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s3_Sergey.mp3')
							},
							{
								name: "Vova",
								code: "ru-RU-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/ru_ru_s4_Vova.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Slovak (Slovakia)', code: 'sk-SK',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Dalenka",
								code: "sk-SK-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.mp3')
							},
							{
								name: "Ladislava",
								code: "sk-SK-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Spanish (Spain)', code: 'es-ES',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Celesta",
								code: "es-ES-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/es_es_s1_Celesta.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Swedish (Sweden)', code: 'sv-SE',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Astrid",
								code: "sv-SE-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/sv_se_s1_Astrid.mp3')
							},
							{
								name: "Caren",
								code: "sv-SE-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/sv_se_s2_Caren.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Turkish (Turkey)', code: 'tr-TR',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Aylin",
								code: "tr-TR-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s1_Aylin.mp3')
							},
							{
								name: "Emel",
								code: "tr-TR-Standard-C",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s2_Emel.mp3')
							},
							{
								name: "Filiz",
								code: "tr-TR-Standard-D",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s3_Filiz.mp3')
							},
							{
								name: "Nehir",
								code: "tr-TR-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s4_Nehir.mp3')
							},
							{
								name: "Reyhan",
								code: "tr-TR-Wavenet-C",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.mp3')
							},
							{
								name: "Zeynep",
								code: "tr-TR-Wavenet-D",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.mp3')
							}
						]
					},
					{
						type: 'male',
						characters: [
							{
								name: "Ahmet",
								code: "tr-TR-Standard-B",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.mp3')
							},
							{
								name: "Ergin",
								code: "tr-TR-Standard-E",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s2_Ergin.mp3')
							},
							{
								name: "Muhammed",
								code: "tr-TR-Wavenet-B",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.mp3')
							},
							{
								name: "Yusuf",
								code: "tr-TR-Wavenet-E",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.mp3')
							}
						]
					}
				]
			},
			{
				language: 'Ukrainian (Ukraine)', code: 'uk-UA',
				voices: [
					{
						type: 'female',
						characters: [
							{
								name: "Maryska",
								code: "uk-UA-Standard-A",
								vendor: "Google",
								voiceType: "Standard",
								voiceSample: require('../../assets/audio/gallery/uk_ua_s1_Maryska.mp3')
							},
							{
								name: "Veronika",
								code: "uk-UA-Wavenet-A",
								vendor: "Google",
								voiceType: "WaveNet",
								voiceSample: require('../../assets/audio/gallery/uk_ua_s2_Veronika.mp3')
							}
						]
					}
				]
			},


		],
		voices: [],
		characters: [],
		selectedLanguage: null,
		selectedVoice: null,
		selectedCharacter: null,
		formats: ['WAV', 'MP3', 'OGG_OPUS'],
		selectedFormat: null,
		userScript: '',
		fileName: '',
		feedbackDialog: false,
		userCharactersLeft: '?',
	},
	mutations: {
		setSelectedLanguage(state, language) {
			state.selectedLanguage = language;
			if (language) {
				state.voices = language.voices;
				if (state.voices.length == 1) {
					state.selectedVoice = state.voices[0];
					state.characters = state.voices[0].characters;
					if (state.characters.length == 1) {
						state.selectedCharacter = state.characters[0];
					}
				} else {
					state.selectedVoice = null;
					state.selectedCharacter = null;
				}
			}
		},
		setSelectedLanguageByCode(state, languageCode) {
			for (var index in state.languages) {
				if (state.languages[index].code == languageCode) {
					state.selectedLanguage = state.languages[index];
					state.voices = state.languages[index].voices;
					break;
				}
			}
		},
		setSelectedVoice(state, voice) {
			state.selectedVoice = voice;
			if (voice) {
				state.characters = voice.characters;
				if (state.characters.length == 1) {
					state.selectedCharacter = state.characters[0];
				} else {
					state.selectedCharacter = null;
				}
			}
		},
		setSelectedCharacter(state, character) {
			state.selectedCharacter = character;
		},
		setFeedbackDialog(state, dialog) {
			state.feedbackDialog = dialog;
		},
		setUserScript(state, script) {
			state.userScript = script;
		},
		setFileName(state, fileName) {
			state.fileName = fileName;
		},
		setSelectedFormat(state, format) {
			state.selectedFormat = format;
		},
		setUserCharactersLeft(state, chars) {
			state.userCharactersLeft = chars;
		}
	},
	getters: {
		language: state => state.selectedLanguage,
		voice: state => state.selectedVoice,
		character: state => state.selectedCharacter,
		userScript: state => state.userScript,
		fileName: state => state.fileName,
		format: state => state.selectedFormat,
		feedbackDialog: state => state.feedbackDialog,
		userCharactersLeft: state => state.userCharactersLeft,
		countries: state => state.countries
	},
	actions: {
	}
})
